import swal from 'sweetalert'
import store from '@/store';
import Vue from 'vue';

// for accessing $modal
const localVue = new Vue();

function error (msg) {
  swal(msg, {
    title: 'Hiba',
    icon: 'error',
    buttons: {
      confirm: {
        text: 'OK',
        value: true,
        visible: true,
        className: '',
        closeModal: true,
      },
    },
  })
}

function info (msg) {
  swal(msg, {
    icon: 'info',
    buttons: {
      confirm: {
        text: 'OK',
        value: true,
        visible: true,
        className: '',
        closeModal: true,
      },
    },
  })
}

function htmlInfo (title, msg) {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = msg
  swal({
    title: title,
    content: wrapper,
  })
}

function success (msg) {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = msg

  swal({
    html: true,
    content: wrapper,
    icon: 'success',
    buttons: {
      confirm: {
        text: 'OK',
        value: true,
        visible: true,
        className: '',
        closeModal: true,
      },
    },
  })
}

function successAndCopy (msg, copyBtnText, textToCopy, copySuccessMsg) {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = msg

  const alertPromise = swal({
    html: true,
    content: wrapper,
    icon: 'success',
    buttons: {
      copy: {
        text: copyBtnText,
        value: 'copy',
        visible: true,
        className: '',
        closeModal: false,
      },
      confirm: {
        text: 'OK',
        value: true,
        visible: true,
        className: '',
        closeModal: true,
      },
    },
  }).then(value => {
    if (value === 'copy') {
      navigator.clipboard.writeText(textToCopy).then(() => {
        swal(copySuccessMsg, {
          icon: 'success',
          buttons: {
            confirm: {
              text: 'OK',
              value: true,
              visible: true,
              className: '',
              closeModal: true,
            },
          },
        })
      })
    }
  })

  // SweetAlert button text is escaped, so inject icon markup after render.
  setTimeout(() => {
    const copyBtn = document.querySelector('.swal-button--copy')
    if (copyBtn) {
      copyBtn.innerHTML = `<i class="copy icon"></i> ${copyBtnText}`
    }
  }, 0)

  return alertPromise
}

function warning (msg) {
  return swal(msg, {
    icon: 'warning',
    buttons: {
      confirm: {
        text: 'OK',
        value: true,
        visible: true,
        className: '',
        closeModal: true,
      },
    },
  })
}

function confirmation (msg) {
  return new Promise((resolve, reject) => {
    swal(msg, {
      icon: 'warning',
      buttons: {
        confirm: {
          text: 'Rendben',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
        cancel: {
          text: 'Mégse',
          value: false,
          visible: true,
          className: 'warning',
          closeModal: true,
        },
      },
    }).then(resp => {
      if (resp) {
        resolve()
      } else {
        reject()
      }
    })
  })
}

function notRegistered (msg) {
  let buttons = {};
  if (!store.state.signupDisabled) {
    buttons.signup = {
      text: 'Regisztráció',
      value: 'signup',
      visible: true,
      className: '',
      closeModal: true,
    };
  }
  swal(msg, {
    icon: 'info',
    buttons: {
      ...buttons,
      login: {
        text: 'Bejelentkezés',
        value: 'login',
        visible: true,
        className: '',
        closeModal: true,
      },
      cancel: {
        text: 'Mégse',
        value: false,
        visible: true,
        className: 'warning',
        closeModal: true,
      },
    },
  }).then(response => {
      // eslint-disable-next-line
      if (response === 'login') {
        // eslint-disable-next-line
        localVue.$modal.show('log-in-modal');
      } else if (response === 'signup') {
        // eslint-disable-next-line
        localVue.$modal.show('sign-up-modal');
      }
    }, // eslint-disable-next-line handle-callback-err,no-unused-vars
    (error) => {
    },
  );
}

export default {
  error: error,
  info: info,
  htmlInfo: htmlInfo,
  success: success,
  successAndCopy: successAndCopy,
  warning: warning,
  confirmation: confirmation,
  notRegistered: notRegistered,
}
